module.exports = __webpack_public_path__ + "static/media/curriculum_program_problemSolving.21b6e9fa.svg";